import Vue from "vue";
import axios from "axios";
import store from "../store";
import router from "../router";

Vue.prototype.$http = axios;
window.axios = axios;
axios.defaults.baseURL = window.Laravel.urlBase + '/api/';
axios.interceptors.request.use(config => {
    config.headers['X-CSRF-TOKEN'] = window.Laravel.csrfToken;
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    if (Vue.ls.get('token')) {
        config.headers['Authorization'] = 'Bearer ' + Vue.ls.get('token');
    }

    return config;
}, error => {
    return Promise.reject(error);
});

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (!error.response) {
        return error
    }

    let errorResponseData = (error.response.data.message) ? error.response.data.message : error.response.data;

    const errors = ["token_invalid", "token_expired", "token_not_provided", "Unauthenticated."];

    if (errorResponseData && errors.includes(errorResponseData)) {
        store.dispatch('auth/unsetAuthUser')
            .then(() => {
                Vue.ls.remove('token')
                router.push({name: 'login'});
            });
    }

    return Promise.reject(error);
});


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/axios.js